var map = {
	"./dragontiger2_en.png": "gOas",
	"./dragontiger2_esp.png": "zhWr",
	"./dragontiger2_th.png": "1TRz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5jGO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/dragontiger2_.*\.png$
// module id = 5jGO
// module chunks = 1